<div class="card-shadow-container">
    <div class="card card-bevel">
        <div class="card-header d-flex justify-content-start align-items-center">
            <span><sbf-tredder-icons class="tredder-icon me-3" name="tredder-icon"></sbf-tredder-icons></span><ng-content select="[header]"></ng-content>
        </div>
        <div class="card-body bg-light-sand"><ng-content select="[body]"></ng-content></div>
        <div class="card-footer d-flex justify-content-between"><ng-content select="[footer]"></ng-content></div>
    </div>
</div>
